export default __webpack_public_path__ + "static/media/google.d34438c5.svg";